import {
  FETCH_LOAD_TRASH_OWNER_REQUEST,
  FETCH_LOAD_TRASH_OWNER_SUCCESS,
  FETCH_LOAD_TRASH_OWNER_FALUIRE,
} from './loadAllTrashOwnersTypes'

const initialState = {
  loading: false,
  allTrashOwnerList: null,
  error: '',
}

const reducer = (state = initialState, action) => {

  switch (action.type) {
    case FETCH_LOAD_TRASH_OWNER_REQUEST : return {
      ...state,
      loading: true,

    }

    case FETCH_LOAD_TRASH_OWNER_SUCCESS : return {
      ...state,
      allTrashOwnerList: action.payload,
      error: '',
      loading: false,
    }

    case FETCH_LOAD_TRASH_OWNER_FALUIRE : return {
      ...state,
      loading: false,
      allTrashOwnerList: null,
      error: action.payload,
    }
    default : return state
  }
}

export default reducer
